import { initContract } from '@ts-rest/core'
import { z } from 'zod'
import { ErrorResponseSchema } from './general'

const contract = initContract()

const MessagingTokenSchema = z.object({
  token: z.string(),
})

export const zendeskContract = contract.router(
  {
    getMessagingToken: {
      method: 'GET',
      path: '/zendesk/messaging-token',
      responses: {
        200: MessagingTokenSchema,
        503: ErrorResponseSchema,
      },
    },
  },
  {
    commonResponses: {
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
)
